export function reMapGetFacilitiesData(applianceJson1) {
  // console.log(applianceJson1);

  let facilities_list = [];
  let floors_list = [];
  let sectors_list = [];
  let shifts_list = [];
  let emp_policies = [];
  let holidays = [];
  let report_alerts = [];
  const companies = applianceJson1.map((comp) => {
    const {
      facilities,
      shifts,
      employee_policies,
      holiday_list,
      report_schedules,
      ...company
    } = comp;
    shifts_list = shifts;
    emp_policies = employee_policies;
    holidays = holiday_list;
    report_alerts = report_schedules;
    facilities
      .filter((fac) =>
        localStorage.getItem("client_name")
          ? fac.facility_type == localStorage.getItem("client_name")
          : true
      )
      .map((fac) => {
        const { floors, ...facility } = fac;
        facilities_list.push(facility);

        floors.map((flo) => {
          let { sectors, ...floor } = flo;

          floors_list.push(floor);
          sectors.map((sec) => {
            sec.facility = facility.id;
            sectors_list.push(sec);
            return sec;
          });
          return floor;
        });

        return facility;
      });

    return company;
  });

  console.log("got facilities");

  const payload = {
    companies: companies.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    facilities: facilities_list.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    floors: floors_list.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    sectors: sectors_list.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    shifts: shifts_list.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    employee_policies: emp_policies.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    holiday_list: holidays.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
    report_alerts: report_alerts.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
  };

  return payload;
}
